function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { posToDOMRect, Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import tippy from 'tippy.js';
var FloatingMenuView = /*#__PURE__*/function () {
  function FloatingMenuView(_ref) {
    var _this = this;
    var editor = _ref.editor,
      element = _ref.element,
      view = _ref.view,
      _ref$tippyOptions = _ref.tippyOptions,
      tippyOptions = _ref$tippyOptions === void 0 ? {} : _ref$tippyOptions,
      shouldShow = _ref.shouldShow;
    _classCallCheck(this, FloatingMenuView);
    this.preventHide = false;
    this.shouldShow = function (_ref2) {
      var view = _ref2.view,
        state = _ref2.state;
      var selection = state.selection;
      var $anchor = selection.$anchor,
        empty = selection.empty;
      var isRootDepth = $anchor.depth === 1;
      var isEmptyTextBlock = $anchor.parent.isTextblock && !$anchor.parent.type.spec.code && !$anchor.parent.textContent;
      if (!view.hasFocus() || !empty || !isRootDepth || !isEmptyTextBlock || !_this.editor.isEditable) {
        return false;
      }
      return true;
    };
    this.mousedownHandler = function () {
      _this.preventHide = true;
    };
    this.focusHandler = function () {
      // we use `setTimeout` to make sure `selection` is already updated
      setTimeout(function () {
        return _this.update(_this.editor.view);
      });
    };
    this.blurHandler = function (_ref3) {
      var event = _ref3.event;
      var _a;
      if (_this.preventHide) {
        _this.preventHide = false;
        return;
      }
      if ((event === null || event === void 0 ? void 0 : event.relatedTarget) && ((_a = _this.element.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
        return;
      }
      _this.hide();
    };
    this.tippyBlurHandler = function (event) {
      _this.blurHandler({
        event: event
      });
    };
    this.editor = editor;
    this.element = element;
    this.view = view;
    if (shouldShow) {
      this.shouldShow = shouldShow;
    }
    this.element.addEventListener('mousedown', this.mousedownHandler, {
      capture: true
    });
    this.editor.on('focus', this.focusHandler);
    this.editor.on('blur', this.blurHandler);
    this.tippyOptions = tippyOptions;
    // Detaches menu content from its current parent
    this.element.remove();
    this.element.style.visibility = 'visible';
  }
  _createClass(FloatingMenuView, [{
    key: "createTooltip",
    value: function createTooltip() {
      var editorElement = this.editor.options.element;
      var editorIsAttached = !!editorElement.parentElement;
      if (this.tippy || !editorIsAttached) {
        return;
      }
      this.tippy = tippy(editorElement, _objectSpread({
        duration: 0,
        getReferenceClientRect: null,
        content: this.element,
        interactive: true,
        trigger: 'manual',
        placement: 'right',
        hideOnClick: 'toggle'
      }, this.tippyOptions));
      // maybe we have to hide tippy on its own blur event as well
      if (this.tippy.popper.firstChild) {
        this.tippy.popper.firstChild.addEventListener('blur', this.tippyBlurHandler);
      }
    }
  }, {
    key: "update",
    value: function update(view, oldState) {
      var _a, _b, _c;
      var state = view.state;
      var doc = state.doc,
        selection = state.selection;
      var from = selection.from,
        to = selection.to;
      var isSame = oldState && oldState.doc.eq(doc) && oldState.selection.eq(selection);
      if (isSame) {
        return;
      }
      this.createTooltip();
      var shouldShow = (_a = this.shouldShow) === null || _a === void 0 ? void 0 : _a.call(this, {
        editor: this.editor,
        view: view,
        state: state,
        oldState: oldState
      });
      if (!shouldShow) {
        this.hide();
        return;
      }
      (_b = this.tippy) === null || _b === void 0 ? void 0 : _b.setProps({
        getReferenceClientRect: ((_c = this.tippyOptions) === null || _c === void 0 ? void 0 : _c.getReferenceClientRect) || function () {
          return posToDOMRect(view, from, to);
        }
      });
      this.show();
    }
  }, {
    key: "show",
    value: function show() {
      var _a;
      (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      var _a;
      (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.hide();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _a, _b;
      if ((_a = this.tippy) === null || _a === void 0 ? void 0 : _a.popper.firstChild) {
        this.tippy.popper.firstChild.removeEventListener('blur', this.tippyBlurHandler);
      }
      (_b = this.tippy) === null || _b === void 0 ? void 0 : _b.destroy();
      this.element.removeEventListener('mousedown', this.mousedownHandler, {
        capture: true
      });
      this.editor.off('focus', this.focusHandler);
      this.editor.off('blur', this.blurHandler);
    }
  }]);
  return FloatingMenuView;
}();
var FloatingMenuPlugin = function FloatingMenuPlugin(options) {
  return new Plugin({
    key: typeof options.pluginKey === 'string' ? new PluginKey(options.pluginKey) : options.pluginKey,
    view: function view(_view) {
      return new FloatingMenuView(_objectSpread({
        view: _view
      }, options));
    }
  });
};
var FloatingMenu = Extension.create({
  name: 'floatingMenu',
  addOptions: function addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: 'floatingMenu',
      shouldShow: null
    };
  },
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    if (!this.options.element) {
      return [];
    }
    return [FloatingMenuPlugin({
      pluginKey: this.options.pluginKey,
      editor: this.editor,
      element: this.options.element,
      tippyOptions: this.options.tippyOptions,
      shouldShow: this.options.shouldShow
    })];
  }
});
export { FloatingMenu, FloatingMenuPlugin, FloatingMenuView, FloatingMenu as default };